export default "__VITE_ASSET__Uaxos2K5__"